import React from "react";
import { Editor } from 'react-draft-wysiwyg';

class DraftEditor extends React.Component{
    constructor(props){
        super(props);
        this.state = {hasError: false};
    }
    static getDerivedStateFromError(){
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo);
    }
    render(){
        if (this.state.hasError){
            return (
                <div className="alert alert-danger mg-t-30 tx-center">
                    <span>Algo salió mal con la última acción que realizaste, por favor <strong>recarga</strong> este sitio</span>
                </div>
            )
        }
        return (
            <Editor {...this.props}/>
        )
    }
} 

export default DraftEditor;